import { useApp } from "daymap-react";
import { Outlet } from "react-router-dom";

function StudentLayout() {
    const { studentAppBarEl } = useApp();
    
    return <div style={{ marginTop: `${studentAppBarEl ? studentAppBarEl?.getBoundingClientRect().height : 0}px`}}>
        <Outlet/>
    </div>
}

export default StudentLayout